import { put, call, take, fork } from 'redux-saga/effects'
import { patchCertificatePaymentSettingService } from 'src/api/certificate'
import {
  patchCertificatePaymentSettingSuccess,
  patchCertificatePaymentSettingError,
} from 'src/reducers/certificate/action'
import { PATCH_CERTIFICATE_PAYMENT_SETTING } from 'src/reducers/certificate/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

function* flow(payload) {
  try {
    const { collectionId, content, callback } = payload
    const response = yield call(
      patchCertificatePaymentSettingService,
      collectionId,
      content,
    )
    yield put(patchCertificatePaymentSettingSuccess(content))
    yield put(operationSuccess())
    if (callback) callback(response?.data ?? response)
  } catch (error) {
    yield put(patchCertificatePaymentSettingError(error))
    yield put(operationFail(error))
  }
}

export default function* patchCertificatePaymentSettingWatcher() {
  while (true) {
    const action = yield take(PATCH_CERTIFICATE_PAYMENT_SETTING)
    yield fork(generalSaga, flow, action.payload)
  }
}
